import React from "react";

import { IAddress } from "shared/types";
import { IContactInfo } from "Venues/types";
import { BaseHeader } from "Venues/components";

interface VenueHeaderDummyProps {
  title?: string;
  address?: IAddress;
  contact?: IContactInfo;
  isCenter?: boolean;
}

export const DummyHeader: React.FC<VenueHeaderDummyProps> = props => (
  <BaseHeader showPlaceholder={true} {...props} />
);
